<script lang="ts">
  import Modal from "$app/components/Modal.svelte"
  import { ShieldUser, Award, ListCheck, Lock } from "lucide-svelte"
  import { appStore } from "$app/store.svelte"

  let props = $props()

  import activityPreview from "@images/free/activity-preview.jpg"
  let openModal = $state(true)
</script>

<div class="w-full">
  <img
    src={activityPreview}
    class="w-full cursor-not-allowed"
    alt="Preview of a Standard Activity Page"
  />
</div>

<Modal
  closeButton={false}
  hasBackdrop={true}
  allowScroll={true}
  closeOnEsc={true}
  closeOnOuterClick={true}
  bind:open={openModal}
>
  <div class="py-2 px-4">
    <p
      class="text-2xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-3xl flex justify-start items-center"
    >
      <Lock class="size-7 text-red-800 mr-2" />
      Activity Page
    </p>
    <p class="mt-6 text-lg/8 text-gray-700">
      The Activity Page is not available at your current Free Subscription
      level. Please upgrade to the Standard Subscription to access all the
      valuable features including the following:
    </p>
    <dl class="mt-6 max-w-xl space-y-6 text-base/7 text-gray-600 lg:max-w-none">
      <div class="relative pl-9">
        <dt class="inline font-semibold text-gray-900">
          <ShieldUser class="size-6 absolute top-1 left-1 text-blue-600" />
          Leadership Development
        </dt>
        <dd class="inline">
          Practice continual education and help everyone on your team become a
          leader through our shared book reading feature.
        </dd>
      </div>
      <div class="relative pl-9">
        <dt class="inline font-semibold text-gray-900">
          <Award class="size-6 absolute top-1 left-1 text-blue-600" />
          Recognitions and Badges
        </dt>
        <dd class="inline">
          See all the recognitions sent in a given week along with any badges
          earned by your team.
        </dd>
      </div>
      <div class="relative pl-9">
        <dt class="inline font-semibold text-gray-900">
          <ListCheck class="size-6 absolute top-1 left-1 text-blue-600" />

          Goal and Task Progress
        </dt>
        <dd class="inline">
          View the current status of all your active Goals and Tasks and view
          any Progress Reports entered in the week.
        </dd>
      </div>
    </dl>
  </div>
  <div class="py-4 px-8 mt-6 flex justify-end border-t border-gray-200">
    <a
      href={`/plans/${appStore.plan.id}/admin`}
      class="rounded-md bg-green-600 px-3.5 py-2.5 text-base font-semibold text-white shadow-xs hover:bg-green-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
      >Upgrade Now</a
    >
  </div>
</Modal>

<style>
  ::backdrop {
    background-color: var(--backdrop-color);
  }
</style>
